<template>
    <div :class="{'has-value': value, 'has-focus': hasFocus}">
        <input
            ref="inputTarget"
            :disabled="disabled"
            class="form-control"
            type="text"
        >
    </div>
</template>
<script>
    import 'intl-tel-input/build/js/utils';
    import intlTelInput from 'intl-tel-input';

    export default {
        name: 'CcIntlPhone',

        props: {
            value: null,
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                hasFocus: false,
                // eslint-disable-next-line vue/no-reserved-keys
                _intl: null,
            };
        },

        mounted() {
            this.$refs.inputTarget.value = this.value;

            this._intl = intlTelInput(this.$refs.inputTarget, {
                initialCountry: 'lt',
                preferredCountries: ['lt'],
                nationalMode: true,
                separateDialCode: true,
                autoPlaceholder: 'off',
                dropdownContainer: document.body,
                localizedCountries: {
                    ad: 'Andora',
                    ae: 'Jungtiniai Arabų Emyratai',
                    af: 'Afganistanas',
                    ag: 'Antigva ir Barbuda',
                    ai: 'Angilija',
                    al: 'Albanija',
                    am: 'Armėnija',
                    ao: 'Angola',
                    ar: 'Argentina',
                    as: 'Amerikos Samoa',
                    at: 'Austrija',
                    au: 'Australija',
                    aw: 'Aruba',
                    ax: 'Alandų salos',
                    az: 'Azerbaidžanas',
                    ba: 'Bosnija ir Hercegovina',
                    bb: 'Barbadosas',
                    bd: 'Bangladešas',
                    be: 'Belgija',
                    bf: 'Burkina Fasas',
                    bg: 'Bulgarija',
                    bh: 'Bahreinas',
                    bi: 'Burundis',
                    bj: 'Beninas',
                    bl: 'Šv. Bartolomėjus',
                    bm: 'Bermudai',
                    bn: 'Brunėjus',
                    bo: 'Bolivija',
                    bq: 'Karibų Nyderlandai',
                    br: 'Brazilija',
                    bs: 'Bahamos',
                    bt: 'Butanas',
                    bw: 'Botsvana',
                    by: 'Baltarusija',
                    bz: 'Belizas',
                    ca: 'Kanada',
                    cc: 'Kokosų (Kilingo) salos',
                    cd: 'Kongas - Kinšasa',
                    cf: 'Centrinės Afrikos Respublika',
                    cg: 'Kongas - Brazavilis',
                    ch: 'Šveicarija',
                    ci: 'Dramblio Kaulo Krantas',
                    ck: 'Kuko salos',
                    cl: 'Čilė',
                    cm: 'Kamerūnas',
                    cn: 'Kinija',
                    co: 'Kolumbija',
                    cr: 'Kosta Rika',
                    cu: 'Kuba',
                    cv: 'Žaliasis Kyšulys',
                    cw: 'Kiurasao',
                    cx: 'Kalėdų sala',
                    cy: 'Kipras',
                    cz: 'Čekija',
                    de: 'Vokietija',
                    dj: 'Džibutis',
                    dk: 'Danija',
                    dm: 'Dominika',
                    do: 'Dominikos Respublika',
                    dz: 'Alžyras',
                    ec: 'Ekvadoras',
                    ee: 'Estija',
                    eg: 'Egiptas',
                    eh: 'Vakarų Sachara',
                    er: 'Eritrėja',
                    es: 'Ispanija',
                    et: 'Etiopija',
                    fi: 'Suomija',
                    fj: 'Fidžis',
                    fk: 'Falklando salos',
                    fm: 'Mikronezija',
                    fo: 'Farerų salos',
                    fr: 'Prancūzija',
                    ga: 'Gabonas',
                    gb: 'Jungtinė Karalystė',
                    gd: 'Grenada',
                    ge: 'Gruzija',
                    gf: 'Prancūzijos Gviana',
                    gg: 'Gernsis',
                    gh: 'Gana',
                    gi: 'Gibraltaras',
                    gl: 'Grenlandija',
                    gm: 'Gambija',
                    gn: 'Gvinėja',
                    gp: 'Gvadelupa',
                    gq: 'Pusiaujo Gvinėja',
                    gr: 'Graikija',
                    gt: 'Gvatemala',
                    gu: 'Guamas',
                    gw: 'Bisau Gvinėja',
                    gy: 'Gajana',
                    hk: 'Honkongas',
                    hn: 'Hondūras',
                    hr: 'Kroatija',
                    ht: 'Haitis',
                    hu: 'Vengrija',
                    id: 'Indonezija',
                    ie: 'Airija',
                    il: 'Izraelis',
                    im: 'Meno sala',
                    in: 'Indija',
                    io: 'Indijos vandenyno britų teritorija',
                    iq: 'Irakas',
                    ir: 'Iranas',
                    is: 'Islandija',
                    it: 'Italija',
                    je: 'Džersis',
                    jm: 'Jamaika',
                    jo: 'Jordanija',
                    jp: 'Japonija',
                    ke: 'Kenija',
                    kg: 'Kirgizija',
                    kh: 'Kambodža',
                    ki: 'Kiribatis',
                    km: 'Komorai',
                    kn: 'Šv. Kitsas ir Nevis',
                    kp: 'Šiaurės Korėja',
                    kr: 'Pietų Korėja',
                    kw: 'Kuveitas',
                    ky: 'Kaimanų salos',
                    kz: 'Kazachstanas',
                    la: 'Laosas',
                    lb: 'Libanas',
                    lc: 'Šv. Liucija',
                    li: 'Lichtenšteinas',
                    lk: 'Šri Lanka',
                    lr: 'Liberija',
                    ls: 'Lesotas',
                    lt: 'Lietuva',
                    lu: 'Liuksemburgas',
                    lv: 'Latvija',
                    ly: 'Libija',
                    ma: 'Marokas',
                    mc: 'Monakas',
                    md: 'Moldova',
                    me: 'Juodkalnija',
                    mf: 'Šv. Martynas',
                    mg: 'Madagaskaras',
                    mh: 'Maršalo salos',
                    mk: 'Šiaurės Makedonija',
                    ml: 'Malis',
                    mm: 'Mianmaras',
                    mn: 'Mongolija',
                    mo: 'Makao',
                    mp: 'Šiaurinės Marianų salos',
                    mq: 'Martinika',
                    mr: 'Mauritanija',
                    ms: 'Montseratas',
                    mt: 'Malta',
                    mu: 'Mauricijus',
                    mv: 'Maldyvai',
                    mw: 'Malavis',
                    mx: 'Meksika',
                    my: 'Malaizija',
                    mz: 'Mozambikas',
                    na: 'Namibija',
                    nc: 'Naujoji Kaledonija',
                    ne: 'Nigeris',
                    nf: 'Norfolko sala',
                    ng: 'Nigerija',
                    ni: 'Nikaragva',
                    nl: 'Nyderlandai',
                    no: 'Norvegija',
                    np: 'Nepalas',
                    nr: 'Nauru',
                    nu: 'Niujė',
                    nz: 'Naujoji Zelandija',
                    om: 'Omanas',
                    pa: 'Panama',
                    pe: 'Peru',
                    pf: 'Prancūzijos Polinezija',
                    pg: 'Papua Naujoji Gvinėja',
                    ph: 'Filipinai',
                    pk: 'Pakistanas',
                    pl: 'Lenkija',
                    pm: 'Šv. Pjeras ir Mikelonas',
                    pr: 'Puerto Rikas',
                    ps: 'Palestinos teritorijos',
                    pt: 'Portugalija',
                    pw: 'Palau',
                    py: 'Paragvajus',
                    qa: 'Kataras',
                    re: 'Reunjonas',
                    ro: 'Rumunija',
                    rs: 'Serbija',
                    ru: 'Rusija',
                    rw: 'Ruanda',
                    sa: 'Saudo Arabija',
                    sb: 'Saliamono salos',
                    sc: 'Seišeliai',
                    sd: 'Sudanas',
                    se: 'Švedija',
                    sg: 'Singapūras',
                    sh: 'Šv. Elena',
                    si: 'Slovėnija',
                    sj: 'Svalbardas ir Janas Majenas',
                    sk: 'Slovakija',
                    sl: 'Siera Leonė',
                    sm: 'San Marinas',
                    sn: 'Senegalas',
                    so: 'Somalis',
                    sr: 'Surinamas',
                    ss: 'Pietų Sudanas',
                    st: 'San Tomė ir Prinsipė',
                    sv: 'Salvadoras',
                    sx: 'Sint Martenas',
                    sy: 'Sirija',
                    sz: 'Esvatinis',
                    tc: 'Terkso ir Kaikoso salos',
                    td: 'Čadas',
                    tg: 'Togas',
                    th: 'Tailandas',
                    tj: 'Tadžikistanas',
                    tk: 'Tokelau',
                    tl: 'Rytų Timoras',
                    tm: 'Turkmėnistanas',
                    tn: 'Tunisas',
                    to: 'Tonga',
                    tr: 'Turkija',
                    tt: 'Trinidadas ir Tobagas',
                    tv: 'Tuvalu',
                    tw: 'Taivanas',
                    tz: 'Tanzanija',
                    ua: 'Ukraina',
                    ug: 'Uganda',
                    us: 'Jungtinės Valstijos',
                    uy: 'Urugvajus',
                    uz: 'Uzbekistanas',
                    va: 'Vatikano Miestas',
                    vc: 'Šv. Vincentas ir Grenadinai',
                    ve: 'Venesuela',
                    vg: 'Britų Mergelių salos',
                    vi: 'JAV Mergelių salos',
                    vn: 'Vietnamas',
                    vu: 'Vanuatu',
                    wf: 'Volisas ir Futuna',
                    ws: 'Samoa',
                    ye: 'Jemenas',
                    yt: 'Majotas',
                    za: 'Pietų Afrika',
                    zm: 'Zambija',
                    zw: 'Zimbabvė',
                },
            });

            this.$refs.inputTarget.addEventListener('countrychange', () => {
                this.$emit('input', this._intl.getNumber());
            });

            this.$refs.inputTarget.addEventListener('change', () => {
                this.$emit('input', this._intl.getNumber());
            });

            this.$refs.inputTarget.addEventListener('focus', () => {
                this.hasFocus = true;
            });

            this.$refs.inputTarget.addEventListener('blur', () => {
                this.hasFocus = false;
                this.$emit('input', this._intl.getNumber());
            });
        },
    };
</script>
